import { ReminderStateType } from '../../services/ReminderService';

export const STATE_LABELS: Record<ReminderStateType, string> = {
  PENDING: 'Beklemede',
  PROCESSING: 'İşlemde',
  ACCEPT: 'Kabul',
  REJECT: 'Reddedildi',
  COMPLETED: 'Tamamlandı',
  CLOSED: 'Kapandı'
};
